import type from './types';

const INITIAL_STATE = {
  loading: true,
  error: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case type.EMAIL_SUBSCRIPTION_LOAD:
      return { ...state, loading: action.payload };
    case type.EMAIL_SUBSCRIPTION_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
